<template>
  <the-new-header></the-new-header>

  <subcribe-modal :modalActive="modalSub" @close="toggleModal()"></subcribe-modal>

  <div class="training-services-section">
    <RouterView></RouterView>
  </div>

  <the-footer></the-footer>
</template>

<script>
export default {
  data () {
    return {
      modalSub: false
    }
  },
  methods: {
    toggleModal () {
      this.modalSub = false
    }
  },
  mounted () {
    if (!sessionStorage.getItem('modalShown')) {
      this.modalSub = true // Open the modal only once per session
      sessionStorage.setItem('modalShown', 'true') // Set flag to prevent re-opening
    }
  }
}
</script>

<style scoped>
  .training-services-section {
    padding: 0 170px;
    min-height: 525px;
  }

  @media (max-width: 1356px) {
    .training-services-section {
      padding: 0 100px;
    }
  }

  @media (max-width: 1080px) {
    .training-services-section {
      padding: 0 50px;
    }
  }

  @media (max-width: 720px) {
    .training-services-section {
      padding: 0px 20px;
    }
  }
</style>
